import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { User } from '../../../@types/user'
import api from '../../../utils/api'
import axiosInstance from '../../../utils/axiosConfig'
import { RootState } from '../../rootReducer'
import { setProcessId, setRichText, setMetaData } from '../index'

export const createDocumentFromTemplate = createAsyncThunk('massiveDocumentCreate/createDocumentFromTemplate', async (data: any[], { rejectWithValue, getState, dispatch }) => {
  const user: User = data[0]
  const usersCode: any = data[1]
  try {

    const state = getState() as RootState
    const { id: userAuthenticatedId } = state.userAuthentication?.user || {}
    const { selectedTemplate: template, legalRep, templateQuestions } = state.massiveDocumentCreate
    const { title, category, signatureProvider } = state.massiveDocumentCreate.document
    const status = state.massiveDocumentCreate.createProcessStatus
    const metaData = state.massiveDocumentCreate.metadata
    const richTextForPdf = state.massiveDocumentCreate.richText
    const processID = state.massiveDocumentCreate.processId

    if (processID === 0) {
      const { data: usersInfoWithCode } = await axiosInstance.get(`${api.baseURL}midtview`, {
        params: {
          where: JSON.stringify({
            id: usersCode
          })
        }
      })

      var dataToCreateProcess = new FormData()

      dataToCreateProcess.append('creator', userAuthenticatedId!)
      dataToCreateProcess.append('metadata', JSON.stringify(usersInfoWithCode))
      dataToCreateProcess.append('title', title!)

      const { data: createProcessResponse } = await axiosInstance.post(`${api.baseURL}process`, dataToCreateProcess)

      const { data: richTextForm } = await axiosInstance.get(`${api.baseURL}form?id=${template!.id}`)

      dispatch(setRichText(richTextForm[0].richText))

      dispatch(setProcessId(createProcessResponse.id))

      dispatch(setMetaData(usersInfoWithCode))

      const {
        data: [userRoleResponse]
      } = await axiosInstance.get(`${api.baseURL}userrole?user=${user.id}`, {
        params: {
          limit: 1,
          enabled: true
        }
      })

      if (!userRoleResponse) throw new Error('Los datos del usuario no pudieron ser encontrados.')

      const {
        data: [miDtgetResponse]
      } = await axiosInstance.get(`${api.baseURL}midtview`, {
        params: {
          where: {
            id: userRoleResponse.code
          },
          limit: 1
        }
      })

      if (!miDtgetResponse) throw new Error('Los datos del usuario no pudieron ser encontrados.')

      var richText = richTextForm[0] || {}
      let element = document.createElement('div')
      element.innerHTML = richText.richText!
      let elementList = element.getElementsByClassName('ql-label') as HTMLCollectionOf<HTMLElement>
      let elementSplit = []

      for (let index = 0; index < elementList.length; index++) {
        const temp = elementList[index].innerText.split('#')
        elementSplit.push(temp)
      }

      // Split a tags ql-label y reemplaza datos en richText de plantilla
      let text = richTextForm[0].richText || {}
      // Cambio tags <code></code> por <span></span>
      // para mejor formateo de texto en el PDF
      text = text ? text.replace(/(<code)/gim, '<span').replace(/<\/code>/gim, '</span>') : ''
      text = text ? text.replace('lightblue', 'white') : ''
      elementSplit.forEach((element) => {
        if (!Array.isArray(element) || typeof element.join !== 'function') {
          console.error('❌ Element no es un array válido para join:', element)
          return
        }

        // Busca pregunta y su tipo
        const found = templateQuestions.find(({ label }) => label === element[0])

        // Agrega campos que los obtiene del UserRole
        const miDtViewData = {
          ...miDtgetResponse,
          emailApiGS: userRoleResponse.user.email ? userRoleResponse.user.email : ''
        }

        if (found) {
          if (found.type === 'user') {
            for (const [key, value] of Object.entries(miDtViewData)) {
              if (key === element[1]) {
                const joinedElement = element.join('#')
                text = text ? text.replace(joinedElement, value ? (value as string) : '') : ''
                text = text ? text.replace('lightblue', 'white') : ''
              }
            }
          }
          if (found.type === 'text') {
            console.log('🔍 Reemplazando en richText:', {
              campo: element[0],
              valor: found.value
            })
            text = text && text.replace(element[0], found.value!)
            text = text ? text.replace('lightblue', 'white') : ''
          }
        }
      })

      // Obtén el token desde localStorage
      const token = localStorage.getItem('token')

      // Genera PDF
      const { data: archiveData } = await axiosInstance.post(
        `${api.baseURL}archive/generate-pdf`,
        {
          text,
          title: `${title} ${user.name}`
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      // Crea el acuerdo
      const { data: documentData } = await axiosInstance.post(
        `${api.baseURL}document`,
        {
          title: `${title} ${user.name}`,
          archive: archiveData.id,
          author: userAuthenticatedId,
          category: category?.id,
          process: createProcessResponse.id,
          signatureProvider: signatureProvider?.id,
          sourceOrganization: state.userAuthentication.user?.sourceOrganization
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      // Crea stakeholders
      if (legalRep.id !== undefined) {
        await Promise.all([
          axiosInstance.post(`${api.baseURL}documentstakeholder`, {
            document: documentData.id,
            stakeholder: legalRep.id,
            type: 'Firmante',
            order: 1
          }),
          axiosInstance.post(`${api.baseURL}documentstakeholder`, {
            document: documentData.id,
            stakeholder: user.id,
            type: 'Firmante',
            order: 2
          })
        ])
      } else {
        await axiosInstance.post(`${api.baseURL}documentstakeholder`, {
          document: documentData.id,
          stakeholder: user.id,
          type: 'Firmante',
          order: 1
        })
      }

      // Activa acuerdo
      axiosInstance.post(`${api.baseURL}document/activate`, {
        document: documentData.id,
        user: state.userAuthentication.user?.id
      })

      return {
        status: 'success',
        documentId: documentData.id,
        userId: user.id,
        title: `${title} ${user.name}`
      }
    }
    if (processID != 0) {
      const {
        data: [userRoleResponse]
      } = await axiosInstance.get(`${api.baseURL}userrole?user=${user.id}`, {
        params: {
          limit: 1,
          enabled: true
        }
      })

      if (!userRoleResponse) throw new Error('Los datos del usuario no pudieron ser encontrados.')

      const {
        data: [miDtgetResponse]
      } = await axiosInstance.get(`${api.baseURL}midtview`, {
        params: {
          where: {
            id: userRoleResponse.code
          },
          limit: 1
        }
      })

      if (!miDtgetResponse) throw new Error('Los datos del usuario no pudieron ser encontrados.')

      var richText = richTextForPdf
      let element = document.createElement('div')
      element.innerHTML = richText!
      let elementList = element.getElementsByClassName('ql-label') as HTMLCollectionOf<HTMLElement>
      let elementSplit = []

      for (let index = 0; index < elementList.length; index++) {
        const temp = elementList[index].innerText.split('#')
        elementSplit.push(temp)
      }

      // Split a tags ql-label y reemplaza datos en richText de plantilla
      let text = richTextForPdf

      // Cambio tags <code></code> por <span></span>
      // para mejor formateo de texto en el PDF
      text = text ? text.replace(/(<code)/gim, '<span').replace(/<\/code>/gim, '</span>') : ''
      text = text ? text.replace('lightblue', 'white') : ''

      elementSplit.forEach((element) => {
        if (!Array.isArray(element) || typeof element.join !== 'function') {
          console.error('❌ Element no es un array válido para join:', element)
          return
        }

        // Busca pregunta y su tipo
        const found = templateQuestions.find(({ label }) => label === element[0])

        // Agrega campos que los obtiene del UserRole
        const miDtViewData = {
          ...miDtgetResponse,
          emailApiGS: userRoleResponse.user.email ? userRoleResponse.user.email : ''
        }
        if (found) {
          if (found.type === 'user') {
            for (const [key, value] of Object.entries(miDtViewData)) {
              if (key === element[1]) {
                const joinedElement = element.join('#')
                text = text ? text.replace(joinedElement, value ? (value as string) : '') : ''
                text = text ? text.replace('lightblue', 'white') : ''
              }
            }
          }
          if (found.type === 'text') {
            text = text && text.replace(element[0], found.value!)
            text = text ? text.replace('lightblue', 'white') : ''
          }
        }
      })

      // Genera PDF
      const { data: archiveData } = await axiosInstance.post(`${api.baseURL}archive/generate-pdf`, {
        text,
        title: `${title} ${user.name}`
      })

      // Crea el acuerdo
      const { data: documentData } = await axiosInstance.post(`${api.baseURL}document`, {
        title: `${title} ${user.name}`,
        archive: archiveData.id,
        author: userAuthenticatedId,
        category: category?.id,
        process: processID,
        signatureProvider: signatureProvider?.id,
        sourceOrganization: state.userAuthentication.user?.sourceOrganization
      })

      try {
        if (legalRep?.id !== undefined) {
          await Promise.all([
            axiosInstance.post(`${api.baseURL}documentstakeholder`, {
              document: documentData.id,
              stakeholder: legalRep.id,
              type: 'Firmante',
              order: 1
            }),
            axiosInstance.post(`${api.baseURL}documentstakeholder`, {
              document: documentData.id,
              stakeholder: user.id,
              type: 'Firmante',
              order: 2
            })
          ])
        } else {
          await axiosInstance.post(`${api.baseURL}documentstakeholder`, {
            document: documentData.id,
            stakeholder: user.id,
            type: 'Firmante',
            order: 1
          })
        }
      } catch (err) {
        console.error('❌ Error al crear firmantes para documento', documentData.id, err)
      }

      // Activa acuerdo
      try {
        await axiosInstance.post(`${api.baseURL}document/activate`, {
          document: documentData.id,
          user: state.userAuthentication.user?.id
        })
      } catch (err) {
        console.error('❌ Error al activar documento', documentData.id, err)
      }

      return {
        status: 'success',
        documentId: documentData.id,
        userId: user.id,
        title: `${title} ${user.name}`
      }
    }

    return
  } catch (error: any) {
    const { message } = error
    rejectWithValue(message)
    throw message
  }
})
